import {
  onAuthStateChanged,
  signInAnonymously,
  type User,
} from 'firebase/auth';
import type { AuthenticationService } from '@core';
import { firebaseAuth } from './firebase';

const waitForInitialAuthState = (): Promise<User | null> =>
  new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(
      firebaseAuth,
      (user) => {
        unsubscribe();
        resolve(user);
      },
      (error) => {
        unsubscribe();
        reject(error);
      },
    );
  });

export const authService: AuthenticationService = {
  async ensureAnonymousSignIn() {
    const existingUser = firebaseAuth.currentUser ?? (await waitForInitialAuthState());

    if (existingUser) {
      return existingUser.uid;
    }

    const credentials = await signInAnonymously(firebaseAuth);
    return credentials.user.uid;
  },

  getCurrentUserID() {
    return firebaseAuth.currentUser?.uid ?? null;
  },
};
